import Detail from './detail';

export default [
  {
    id: 'device',
    name: 'Device',
    path: ':site?/:location?/:bridge?/:panel?/:controller?/:circuit?',
    Component: Detail
  }
];
